import { Heading, TextField } from "@elaniintc/goes-design-system";
import { ScopeField } from "../components/scope-selector";
import SwitchField from "../../form/components/SwitchField";
import { DCCondition } from "../components/condition";
import { useDataCenterNode } from "../context";
import { useCallback } from "react";
import { useMaskito } from "@maskito/react";

const numberMskConfig = {
  options: {
    mask: [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
  },
};

interface DCReadFormProps {
  executeQuery: boolean;
  setExecuteQuery: (value: boolean) => void;
  multipleSelected: boolean;
  setMultipleSelected: (value: boolean) => void;
}

export const DCReadForm = ({
  executeQuery,
  setExecuteQuery,
  multipleSelected,
  setMultipleSelected,
}: DCReadFormProps) => {
  const { columnsDef, multipleCount, setMultipleCount } = useDataCenterNode();
  const numberMask = useMaskito(numberMskConfig);
  const handleCountChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const next = Number(e.target.value || 0);
      if (Number.isNaN(next)) return;
      setMultipleCount(next);
    },
    [setMultipleCount],
  );

  return (
    <>
      <div className="w-full pt-3 pb-6 px-4 border-b-1 border-neutral-quiet flex flex-col gap-1">
        <Heading variant="h6">Búsqueda de registros</Heading>
        <div className="flex flex-col gap-4">
          <ScopeField />
          <DCCondition className="p-0" variables={columnsDef} buttonSize="xs" />
          <SwitchField
            label="Múltiples resultados"
            checked={multipleSelected}
            onChange={setMultipleSelected}
            required
            isFalse="No, solo el primer registro que haga match"
          />
          {multipleSelected && (
            <TextField
              label="Cantidad de resultados"
              required
              placeholder="Escribe la cantidad de resultados"
              helperText="Escribe la cantidad de resultados a obtener."
              maxLength={15}
              value={multipleCount}
              onChange={handleCountChange}
              ref={(el) => {
                numberMask(el);
              }}
            />
          )}
          <SwitchField
            label="Ejecutar consulta"
            checked={executeQuery}
            onChange={setExecuteQuery}
            required
            isFalse="No, no ejecutar consulta automáticamente"
          />
        </div>
      </div>
    </>
  );
};
